import moment from "moment";
import slugify from "slugify";

/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  getActiveAppointments: (state, getters) => {
    if (!state.userData.AppActiveLocations.length) {
      return [];
    }
    //const old = state.userData.AppActiveAppointments.find(a => moment(a.startDate) < moment() && moment(a.startDate) > moment().subtract(1, 'week'))
    const upcoming = state.userData.AppActiveAppointments.filter(a => {
      return moment(a.startDate) > moment();
    })
    const result2 = [];
    //if (old) result2.push(old);
    if (upcoming.length > 0) result2.push(...upcoming);
    const result3 = result2.map(a => {
      const loc = state.userData.AppActiveLocations.find(loc => loc.idLocation === a.idLocation);
      return {
        ...a,
        loc
      }
    })
    return result3;
  },
  getAllAppointments: (state, getters) => {
    if (!state.userData.AppActiveLocations.length) {
      return [];
    }
    return state.userData.AppActiveAppointments.map(a => {
      const loc = state.userData.AppActiveLocations.find(loc => loc.idLocation === a.idLocation);
      return {
        ...a,
        loc: loc && loc
      }
    })

  },

  getActiveLocations: (state, getters) => {
    if (!state.userData.AppActiveLocations.length) {
      return [];
    }
    //
    let locations = [];
    locations = state.userData.AppActiveClients.map(c => {
      return state.userData.AppActiveLocations.find(loc => {
        return loc.idLocation === c.idLocation && loc && c.isValid === true;
      })
    })
    //(locations);
    const filtered = locations.filter((el) => {
      if (el) return el;
    });
    return [...new Set(filtered)]
  },

  getAllNews: (state, getters) => {
    if (!state.userData.AppActiveLocations.length) {
      return [];
    }
    if (getters.getActiveLocations.length) {
      const a = state.userData.AppActiveNews.map(n => {
        const b = state.userData.AppActiveClients.find(c => {
          return n.idCompany === c.idCompany && c.isValid === true && n.published && n.valid
        })
        //
        const loc = getters.getActiveLocations.find(loc => loc && b && loc.idLocation === b.idLocation);
        //
        if (loc && n) {
          return ({
            ...n,
            loc
          });
        }
      })
      // return a;
      return a.filter(n => n !== undefined);
    } else {
      return []
    }
  },
  getDashboardHcfInfo: state => {
    if (state.hcfInfo !== {}) {
      return {
        interestRate: Number(state.hcfInfo.interestRate) * 100,
        minAmount: Number(state.hcfInfo.minimalAmount) / 1000,
        maxAmount: Number(state.hcfInfo.maximalAmount) / 1000,
        stepAmount: Number(state.hcfInfo.stepAmount) / 1000,
        minMonths: Number(state.hcfInfo.minimumMonths),
        maxMonths: Number(state.hcfInfo.maximumMonths),
        stepMonths: Number(state.hcfInfo.stepMonths)
      };
    }
  },
  getSideBarMenuLocations: (state, getters) => {
    if (!state.userData.AppActiveLocations.length) {
      return [];
    }
    return getters.getActiveLocations.map(loc => {
      return {
        url: `/companies/${loc.idLocation}`,
        name: loc.nameOnline || loc.name,
        slug: `company${loc.name}`
      }
    })
  },
  getLocationsByCompanyId: state => {
    if (!state.userData.AppActiveLocations.length) {
      return [];
    }
    return comId => {
      return state.userData.AppActiveLocations.filter(l => {
        return l.idCompany === comId;
      })
    }
  },
  getClientByLocationId: state => {
    return locId => {
      const client = state.userData.AppActiveClients.find(c => c.idLocation === locId);
      if (client) {
        return client;
      }
    }
  },
  getClientByCompany: state => {
    return locId => {
      return state.userData.AppActiveClients.find(c => {
        const location = state.userData.AppActiveLocations.find(loc => loc.idLocation === locId);
        const comp = state.userData.AppActiveCompanies.find(comp => comp.idCompany === location.idCompany);
        return c.idCompany === comp.idCompany && c.isValid;
      })
    }
  },
  getActualClients: (state, getters) => {
    return getters.getActiveLocations.map(l => {
      return getters.getClientByLocationId(l.idLocation)
    })
  },
  getCreditsByCompany: state => {

  }
}

export default getters
